<template>
  <validation-observer
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="additional-marketing"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row
        :label="companyMarketingText.title"
        class="marketing-actions"
      >
        <form-section-question slot="question">
          <span
            v-html="companyMarketingText.subtitle"
          />
        </form-section-question>
        <div class="option-row">
          <h2 class="label">Email</h2>
          <validation-provider
            v-slot="{ failed }"
            vid="additional-marketing-email"
            name="Additional Marketing Email"
            rules="required"
          >
            <radio
              v-model="questionData.companyMarketingEmail"
              name="Additional Marketing Email"
              :data-test="snakeCase(questionFields.companyMarketingEmail)"
              :items="constants.YES_NO"
              :error="failed"
            />
          </validation-provider>
        </div>
        <div class="option-row">
          <h2 class="label">SMS</h2>
          <validation-provider
            v-slot="{ failed }"
            vid="additional-marketing-sms"
            name="Additional Marketing SMS"
            rules="required"
          >
            <radio
              v-model="questionData.companyMarketingSms"
              name="Additional Marketing SMS"
              :data-test="snakeCase(questionFields.companyMarketingSms)"
              :items="constants.YES_NO"
              :error="failed"
            />
          </validation-provider>
        </div>
      </form-row>
      <div
        v-if="observer.failed"
        class="error--text mt-4 fz12"
      >
        Please select your additional quote preferences.
      </div>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base';

export default {
  name: 'question-marketing-additional',
  inject: ['config'],
  extends: QuestionBase,
  data () {
    return {
      fields: ['companyMarketingEmail', 'companyMarketingSms'],
    };
  },
  computed: {
    companyMarketingText () {
      return { ...this.config.companyMarketingText };
    },
  },
};
</script>

<style lang='scss' scoped>
.label {
  min-width: 80px;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: bold;
}

.marketing-actions {
  &::v-deep {
    .radio-holder:not(.column) {
      margin: 0 -12px;

      .radio-item {
        height: 56px;
        padding: 0 12px;
      }
    }
  }
}

.option-row {
  display: flex;
  flex-direction: column;

  & + .option-row {
    margin-top: 12px;
  }

  @media screen and (min-width: 365px) {
    flex-direction: row;
    align-items: center;

    .label {
      margin-bottom: 0;
      margin-right: 20px;
    }
  }
}
</style>
